<template>
  <section class="cfo-panel" :class="scope.clsPrefix">
    <div class="tool-grid">
      <div v-for="(group, gi) in toolGroups" :key="gi" class="tool-panel">
        <div class="tool-head">{{ group.title }}</div>
        <div class="tool-links">
          <div
            v-for="(tool, ti) in group.tools"
            :key="ti"
            class="tool-link"
            @click="handleOpenTool(tool)"
          >
            <span class="tool-arrow">▶</span>
            <span class="tool-name">{{ tool.name }}</span>
            <span class="tool-badge">{{ tool.badge }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CfoAnalysisTools',
  data() {
    return {
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-cfo-analysis-tools'
      },
      toolGroups: [
        {
          title: '经营分析',
          tools: [
            { id: 'tool-fpa-1', name: 'E2E损益表', badge: 'FPA' },
            { id: 'tool-fpa-2', name: '月度毛利率预测', badge: 'FPA' },
            { id: 'tool-fpa-3', name: 'What-if情景模拟', badge: 'FPA' }
          ]
        },
        {
          title: '敏感性&材差',
          tools: [
            { id: 'tool-fa-1', name: '毛利率影响因素分析', badge: 'FA' },
            { id: 'tool-fa-2', name: '采购价格差异追踪', badge: 'FA' },
            { id: 'tool-fa-3', name: '预测偏差回溯', badge: 'FA' }
          ]
        },
        {
          title: '月结&数据治理',
          tools: [
            { id: 'tool-ctrl-1', name: '月结关账看板', badge: 'CTRL' },
            { id: 'tool-ctrl-2', name: '数据可信度矩阵', badge: 'CTRL' },
            { id: 'tool-ctrl-3', name: 'E2E口径一致性校验', badge: 'CTRL' }
          ]
        },
        {
          title: '现金流&预算',
          tools: [
            { id: 'tool-track-1', name: '现金流监控驾驶舱', badge: 'TRACK' },
            { id: 'tool-track-2', name: '预算执行率热力图', badge: 'TRACK' },
            { id: 'tool-track-3', name: '营运资金分析', badge: 'TRACK' }
          ]
        }
      ]
    }
  },
  methods: {
    handleOpenTool(tool) {
      this.$emit('open-tool', { id: tool.id, title: tool.name })
    }
  }
}
</script>

<style lang="scss" scoped>
.rvc-cosmoplat-workspace-cfo-analysis-tools {
  padding: 0;
  background: transparent;
  border: none;
  box-shadow: none;
  box-sizing: border-box;

  .tool-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }

  .tool-panel {
    background: #fff;
    border-radius: 4px;
    padding: 16px;
    box-sizing: border-box;
    min-width: 0;
  }

  .tool-head {
    margin: 0 0 10px;
    font-size: 14px;
    font-weight: 600;
    color: #1e2226;
    line-height: 20px;
  }

  .tool-links {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .tool-link {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    border-radius: 6px;
    background: #f3f5fb;
    cursor: pointer;
    transition: background 0.15s ease;
    min-width: 0;

    &:hover {
      background: #e8ecf8;
    }
  }

  .tool-arrow {
    flex-shrink: 0;
    font-size: 10px;
    color: #4a5ff3;
    line-height: 1;
  }

  .tool-name {
    flex: 1;
    min-width: 0;
    font-size: 13px;
    font-weight: 500;
    color: #333;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .tool-badge {
    flex-shrink: 0;
    font-size: 11px;
    font-weight: 500;
    color: #8b9ad4;
    letter-spacing: 0.02em;
  }
}

@media screen and (max-width: 900px) {
  .rvc-cosmoplat-workspace-cfo-analysis-tools {
    .tool-grid {
      grid-template-columns: 1fr;
    }
  }
}
</style>
